import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import SubscriptionControlLayer from "../components/SubscriptionControlLayer";
import SubscriptionPlansLayer from "../components/SubscriptionPlansLayer";

const SubscriptionControlPage = () => {
  const [activeTab, setActiveTab] = useState('plans');

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Subscription & Revenue Control" />
        
        <ul className="nav nav-pills mb-24 gap-2" role="tablist">
            <li className="nav-item">
                <button 
                    className={`nav-link ${activeTab === 'plans' ? 'active bg-primary-600 text-white' : 'bg-base text-secondary-light'}`}
                    onClick={() => setActiveTab('plans')}
                >
                    Plan Configuration
                </button>
            </li>
            <li className="nav-item">
                <button 
                    className={`nav-link ${activeTab === 'users' ? 'active bg-primary-600 text-white' : 'bg-base text-secondary-light'}`}
                    onClick={() => setActiveTab('users')}
                >
                    User Subscriptions
                </button>
            </li>
        </ul>

        {activeTab === 'plans' ? <SubscriptionPlansLayer /> : <SubscriptionControlLayer />}
      </MasterLayout>
    </>
  );
};

export default SubscriptionControlPage;
